import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import firebaseDB from "./firebase";
import './contact.css';
import game from '../assets/img/contact.png'
import { getDatabase, ref, set } from "firebase/database";
import Navbars from '../NavbarPrice';
import { FooterPrice } from '../FooterPrice';

export const Contactfrom = () => {
  const [state, setState] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const { name, email, subject, message } = state;
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !email || !subject || !message) {
      toast.error("Please provide value in each input field");
    } else {
      firebaseDB.child("contacts").push(state);
      
      setState({ name: "", email: "", subject: "", message: "" });
      toast.success("Form Submitted Successfully");
    }
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  return(
  
   <section className="a">
        <Navbars/>
        {/**/}
        <ToastContainer position="top-center"/> 
         {/**/}
         
         
          <form
                id="contactForm"
                className="contactForm"
                onSubmit={handleSubmit}
                >
                  {/*<img className="center" src={game} alt="Header Img" width="5" height="5"/>*/}
                  {/*<img className="center" src={game} alt="Header Img" width="5" height="5"/>*/}
                <h1 color="black">Contact Us</h1>
                <div className="mb-3">
                <div  className = "form-group-text">
                <label for="text" class="form-label">Name</label>
                
                <input 
                  
                  type="text" 
                  className="form-control" 
                  name="name" 
                  placeholder="name"
                  onChange={handleInputChange}
                  value={name}
                  id="text" 
                  />
                  <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
                </div>
                
                </div> 

                <div className="mb-3 ">
                <div className = "form-group-text">
                <label for="email" class="form-label">Email</label>
  
                <input 
                  
                  type="email" 
                  className="form-control" 
                  name="email" 
                  placeholder="Email"
                  onChange={handleInputChange}
                  value={email}
                  id="email" 
                  />
                  <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
                </div>
                </div>

                <div className="mb-3">
                <div  className = "form-group-text">
                <label for="subject" class="form-label">Subject</label>  
                <input 
                  
                  type="text" 
                  className="form-control" 
                  name="subject" 
                  placeholder="Subject"
                  onChange={handleInputChange}
                  value={subject}
                  id="subject" 
                  />
                
                </div>
                </div>
                
                <div className="mb-3">
                <div  className = "form-group-text">
                <label for="message" class="form-label">Message</label>  
  
                <textarea 
                type ="text"
                className="form-control" 
                name="message"
                placeholder="Message"
                cols="30"
                onChange={handleInputChange}
                rows="6"
                value={message}
                id="message"
                ></textarea>
                </div>
                </div>


                <button type="submit" value="Send Message" class="btn btn-primary">Submit</button>
                

        </form>
        {/* <FooterPrice/> */}
</section> 

  )
};
